import {post, put} from "./api";

const BASE_URL = '';

export const postLogin = (body) => post(`${BASE_URL}/login`, body);
export const postSignUp = (body) => post(`${BASE_URL}/registration`, body);
export const postForgotPassword = (body) => post(`${BASE_URL}/reset-password`, body);
export const putResetPassword = (body, token) => put(`${BASE_URL}/reset-password?token=${token}`, body);
